export const JTW_S4_STORY_LINE_ID = 'journey-to-the-west-s4';
export const JTW_S4_C1_P1_ID = 'jtw-s4-c1-p1';
export const JTW_S4_C1_P2_ID = 'jtw-s4-c1-p2';
export const JTW_S4_C1_P3_ID = 'jtw-s4-c1-p3';
export const JTW_S4_C1_P4_ID = 'jtw-s4-c1-p4';
export const JTW_S4_C1_P5_ID = 'jtw-s4-c1-p5';
export const JTW_S4_C1_P6_ID = 'jtw-s4-c1-p6';
export const JTW_S4_C1_P7_ID = 'jtw-s4-c1-p7';
export const JTW_S4_C1_P8_ID = 'jtw-s4-c1-p8';
export const JTW_S4_C1_SEAL_ID = 'jtw-s4-c1-suitable-not-loudest-seal';
export const JTW_S4_C2_P1_ID = 'jtw-s4-c2-p1';
export const JTW_S4_C2_P2_ID = 'jtw-s4-c2-p2';
export const JTW_S4_C2_P3_ID = 'jtw-s4-c2-p3';
export const JTW_S4_C2_P4_ID = 'jtw-s4-c2-p4';
export const JTW_S4_C2_P5_ID = 'jtw-s4-c2-p5';
export const JTW_S4_C2_P6_ID = 'jtw-s4-c2-p6';
export const JTW_S4_C2_P7_ID = 'jtw-s4-c2-p7';
export const JTW_S4_C2_P8_ID = 'jtw-s4-c2-p8';
export const JTW_S4_C2_SEAL_ID = 'jtw-s4-c2-listening-boundaries-seal';
export const JTW_S4_C3_P1_ID = 'jtw-s4-c3-p1';
export const JTW_S4_C3_P2_ID = 'jtw-s4-c3-p2';
export const JTW_S4_C3_P3_ID = 'jtw-s4-c3-p3';
export const JTW_S4_C3_P4_ID = 'jtw-s4-c3-p4';
export const JTW_S4_C3_P5_ID = 'jtw-s4-c3-p5';
export const JTW_S4_C3_P6_ID = 'jtw-s4-c3-p6';
export const JTW_S4_C3_P7_ID = 'jtw-s4-c3-p7';
export const JTW_S4_C3_P8_ID = 'jtw-s4-c3-p8';
export const JTW_S4_C3_SEAL_ID = 'jtw-s4-c3-ab-evidence-seal';
export const JTW_S4_C4_P1_ID = 'jtw-s4-c4-p1';
export const JTW_S4_C4_P2_ID = 'jtw-s4-c4-p2';
export const JTW_S4_C4_P3_ID = 'jtw-s4-c4-p3';
export const JTW_S4_C4_P8_ID = 'jtw-s4-c4-p8';
export const JTW_S4_C4_SEAL_ID = 'jtw-s4-c4-failure-has-information-seal';
export const JTW_S4_C5_P1_ID = 'jtw-s4-c5-p1';
export const JTW_S4_C5_P2_ID = 'jtw-s4-c5-p2';
export const JTW_S4_C5_P3_ID = 'jtw-s4-c5-p3';
export const JTW_S4_C5_P4_ID = 'jtw-s4-c5-p4';
export const JTW_S4_C5_P5_ID = 'jtw-s4-c5-p5';
export const JTW_S4_C5_P6_ID = 'jtw-s4-c5-p6';
export const JTW_S4_C5_P7_ID = 'jtw-s4-c5-p7';
export const JTW_S4_C5_P8_ID = 'jtw-s4-c5-p8';
export const JTW_S4_C5_SEAL_ID = 'jtw-s4-c5-three-iterations-seal';
export const JTW_S4_C6_P1_ID = 'jtw-s4-c6-p1';
export const JTW_S4_C6_P2_ID = 'jtw-s4-c6-p2';
export const JTW_S4_C6_P3_ID = 'jtw-s4-c6-p3';
export const JTW_S4_C6_P4_ID = 'jtw-s4-c6-p4';
export const JTW_S4_C6_P5_ID = 'jtw-s4-c6-p5';
export const JTW_S4_C6_P6_ID = 'jtw-s4-c6-p6';
export const JTW_S4_C6_P7_ID = 'jtw-s4-c6-p7';
export const JTW_S4_C6_P8_ID = 'jtw-s4-c6-p8';
export const JTW_S4_C6_SEAL_ID = 'jtw-s4-c6-tested-not-destination-seal';

export const JTW_S4_CHAPTER_TITLES = [
  'Choose a Tool by Its Result',
  'A Respectful Goodbye',
  'Compare Two Versions Fairly',
  'Keep What Happened in the First Try',
  'Change One Thing at a Time',
  'Test an Entrance Before Trusting It',
] as const;

export const JTW_S4_PART_IDS = Array.from({ length: 6 }, (_, chapterIndex) =>
  Array.from({ length: 8 }, (_, partIndex) => `jtw-s4-c${chapterIndex + 1}-p${partIndex + 1}`),
).flat();
